/* eslint-disable camelcase */
import moment from 'moment';
import isNil from 'lodash/isNil';
import { Client } from './Client';
import { Agent } from './Agent';
import { User } from './User';

export enum TourStatus {
  Idle = 'idle',
  Ready = 'ready',
  Error = 'error',
  Pay = 'pay',
}

// eslint-disable-next-line import/export
export enum TourMode {
  DOLLHOUSE = 'mode.dollhouse',
  FLOORPLAN = 'mode.floorplan',
  INSIDE = 'mode.inside',
  OUTSIDE = 'mode.outside',
  TRANSITIONING = 'mode.transitioning',
}

export enum UnitSystem {
  Metric = 'metric',
  Imperial = 'imperial',
}

export enum AssetPageType {
  Classic = 'classic',
  Slick = 'slick',
  Modern = 'modern',
}

export enum CustomButtonTypeOpenAsType {
  Iframe = 'iframe',
  Tab = 'tab',
}

export enum WeekDays {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

export enum TourType {
  Regular = 'regular',
  Game = 'game',
  ECommerce = 'ecommerce',
  Ticket = 'ticket',
  Kiosk = 'kiosk',
}

export const TourTypeURL = {
  regular: 'tour',
  game: 'game',
  ecommerce: 'e-commerce-tour',
  ticket: 'ticket',
  video: 'video',
  experience: 'experience',
  kiosk: 'kiosk',
};

export enum TagDockSideType {
  Right = 'right',
  Left = 'left',
}

export const TourAddons = {
  title: 0,
  brand: false,
  hl: 0,
  tourcta: 1,
  dh: true,
  mt: true,
  nozoom: true,
  pin: true,
  mls: 0,
  qs: false,
  gt: true,
  portal: true,
  f: true,
  wh: true,
  kb: true,
  lp: false,
  vr: true,
  ts: -1,
  help: -1,
  nt: false,
  search: false,
  hidetags: false,
  lang: '',
};

export enum AdRes {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export class Tour {
  id?: number;

  pay: boolean;

  waitingPayment: boolean;

  languageId: number;

  clientId?: number;

  userId?: number;

  parentId?: number;

  error?: string;

  title: string;

  password: string;

  mainImage: string;

  address: string;

  internalAddress: string;

  autoplayVideo: boolean;

  adLeads: boolean;

  size: number;

  beds: number;

  cars: number;

  showers: number;

  accomodation: string;

  vrUrl: string;

  summary: string;

  minimap: boolean;

  panorama: boolean;

  bookUrl: string;

  bookText: string;

  bookColor: string;

  floorPlansEnabled: boolean;

  customMinimap: boolean;

  menuEnabled: boolean;

  menuOnStart: boolean;

  menuAlwaysOpenDesktop: boolean;

  menuAlwaysOpenMobile: boolean;

  exploreText: string;

  ad: boolean;

  adTime: number;

  adRes: AdRes;

  adResMobile: AdRes;

  adWidth: number;

  adHeight: number;

  adWidthMobile: number;

  adHeightMobile: number;

  adUrl: string;

  droneUrl: string;

  videoUrl: string;

  videoWidth: string;

  videoHeight: string;

  status: TourStatus;

  matterId: string;

  images: any[];

  tags: any[];

  floorPlans: any[];

  updatedAt: any;

  client: Client | null;

  publicId: any;

  scannedAt: string;

  disableContext: boolean;

  screenshotEnabled: boolean;

  contactForm: boolean;

  music: boolean;

  autoplayMusic: boolean;

  clientFolderId: number;

  tokenDuration: number;

  unbranded: boolean;

  description: number;

  fee: number;

  unitSystem: UnitSystem;

  appointmentsOn: boolean;

  agentSelecting: boolean;

  appointmentTooltipOn: boolean;

  enableAvatar: boolean;

  enableIot: boolean;

  iot2FAEnabled: boolean;

  imageInsteadOfAvatar: boolean;

  getInTouchTooltipOn: boolean;

  menuTooltipOn: boolean;

  timezone: number;

  user: any;

  users: any;

  sweepGroups: any[];

  appointmentTime: number;

  assetPageType: AssetPageType;

  agents: Agent[];

  useSlug: boolean;

  slug: string;

  messengerLink: string;

  messengerGreeting: string;

  share: boolean;

  allowedDomains: string[];

  assetPageSocialSharing: boolean;

  translation: any;

  brightness: number;

  saturation: number;

  contrast: number;

  collectLeads: boolean;

  leadsEmail: boolean;

  leadsPhone: boolean;

  leadsTimedPhone: boolean;

  leadsTimedName: boolean;

  leadsTimedEmail: boolean;

  leadsComment: string;

  reel: boolean;

  reels: any[];

  reelCategories: any[];

  panoramaStart: boolean;

  panoramaCompass: boolean;

  panoramaHd: boolean;

  // addons
  addon_title: number;

  addon_brand: boolean;

  addon_hl: number;

  addon_tourcta: number;

  addon_dh: boolean;

  addon_mt: boolean;

  addon_nozoom: boolean;

  addon_pin: boolean;

  addon_mls: number;

  addon_qs: boolean;

  addon_gt: boolean;

  addon_portal: boolean;

  addon_f: boolean;

  addon_wh: boolean;

  addon_kb: boolean;

  addon_lp: boolean;

  addon_vr: boolean;

  addon_ts: number;

  addon_help: number;

  addon_nt: boolean;

  addon_search: boolean;

  addon_hidetags: boolean;

  hideMinimapHotspots: boolean;

  showIotOnMinimap: boolean;

  allowGuestBeforeHost: boolean;

  enableBlackColorMenu: boolean;

  vsRenderRange: number;

  vsAnimationDistance: number;

  legalNote: string;

  legalBookingBox: string;

  legalBookingBox2: string;

  termsUrl: string;

  mpReel: boolean;

  mpPlay: boolean;

  tourEmail: any;

  noAudioMode: boolean;

  hidePucks: boolean;

  menuSearch: boolean;

  menuCategoryExpand: boolean;

  hideCookie: boolean;

  mode: TourType;

  registrationBackground: string;

  introScreen: any;

  gameId: number;

  hideClientContact: boolean;

  mpPasswordActive: boolean;

  musics: any[];

  enableVS: boolean;

  htmlActive: boolean;

  htmlCode: string;

  amenities: string;

  showNavTools: boolean;

  stopAfterSweep: number;

  rotationAngle: number;

  rotationSpeed: number;

  transitionSpeed: number;

  showNavPath: boolean;

  walkNav: boolean;

  teleportNav: boolean;

  autoNav: boolean;

  ticket: boolean;

  minimapVisible: boolean;

  subTitle: string;

  panoramaTransition: boolean;

  customButton: boolean;

  customButtonIcon: string;

  customButtonUrl: string;

  customButtonOpenAs: CustomButtonTypeOpenAsType;

  ecommercePaidStatus: boolean;

  ecommerceSubscriptionId: number;

  showTitle: boolean;

  musicControl: boolean;

  assetDescription: string;

  price: string;

  initialDuplicates: any;

  storeEnabled: boolean;

  hideSidebarConfigs: boolean;

  hideSoundControls: boolean;

  hideLanguageSelect: boolean;

  hideSubtitlesSelect: boolean;

  callIconEnabled: boolean;

  addressIconEnabled: boolean;

  ss: string;

  sr: string;

  background: string;

  backgroundImage: string;

  hideMPTagSwitcher: boolean;

  hideMPTagDock: boolean;

  cookieIsMandatory: boolean;

  loadTourAfterCookie: boolean;

  cookieBackgroundImage?: string;

  cookieBackgroundVideo?: string;

  cookieBackgroundVideoUrl?: string;

  oauthAccess: boolean;

  audioVolume: number;

  mpTagDockSide: TagDockSideType;

  patchIcon?: string;

  sameMusicForAllFloors: boolean;

  patchIconEnabled: boolean;

  isThreadsEnabled: boolean;

  isPublic: boolean;

  tagNotesEnabled: boolean;

  guestNotesAccess: boolean;

  notesTaskManagerModeEnabled: boolean;

  textChatEnabled: boolean;

  navigationWebEnabled: boolean;

  activeNotesIntegration: 'icl' | 'bazan' | null;

  isSample: boolean;

  calculateDistanceIn: string;

  layersEnabled: boolean;
  layersStartView: boolean;
  layersCloseButton: boolean;

  smartLogoActive: boolean;

  smartLogoAlignment: string | null;

  smartLogoUrl: string | null;
  taiDesign: boolean;
  taiChat: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.introScreen = model.introScreen || null;
    this.subTitle = model.subTitle || null;
    this.slug = model.slug || null;
    this.useSlug = model.useSlug || false;
    this.panoramaTransition = model.panoramaTransition || false;
    this.ticket = model.ticket || false;
    this.minimapVisible = model.minimapVisible || false;
    this.pay = model.pay;
    this.waitingPayment = model.waitingPayment;
    this.clientId = model.clientId || null;
    this.userId = model.userId || null;
    this.parentId = model.parentId || null;
    this.user = model.user ? new User(model.user) : null;
    this.users = model.users ? [...model.users.map((user) => new User(user))] : null;
    this.adLeads = model.adLeads || false;
    this.sameMusicForAllFloors = model.sameMusicForAllFloors;
    this.error = model.error || null;
    this.title = model.title || null;
    this.password = model.password || null;
    this.mainImage = model.mainImage || null;
    this.address = model.address || null;
    this.internalAddress = model.internalAddress || null;
    this.size = model.size || null;
    this.beds = model.beds || null;
    this.cars = model.cars || null;
    this.showers = model.showers || null;
    this.accomodation = model.accomodation || null;
    this.vrUrl = model.vrUrl || null;
    this.summary = model.summary || null;
    this.minimap = model.minimap || null;
    this.panorama = model.panorama || null;
    this.autoplayVideo = model.autoplayVideo || false;
    this.disableContext = model.disableContext || false;
    this.bookUrl = model.bookUrl || null;
    this.bookText = model.bookText || null;
    this.bookColor = model.bookColor || '#292929';
    this.exploreText = model.exploreText || null;
    this.ad = model.ad || false;
    this.share = model.share || false;
    this.adTime = model.adTime || null;
    this.adRes = model.adRes || AdRes.Percentage;
    this.adResMobile = model.adResMobile || AdRes.Percentage;
    this.adWidth = model.adWidth || 80;
    this.adHeight = model.adHeight || 60;
    this.adWidthMobile = model.adWidthMobile || 80;
    this.adHeightMobile = model.adHeightMobile || 60;
    this.adUrl = model.adUrl || null;
    this.droneUrl = model.droneUrl || null;
    this.videoUrl = model.videoUrl || null;
    this.videoWidth = model.videoWidth || null;
    this.videoHeight = model.videoHeight || null;
    this.floorPlansEnabled = model.floorPlansEnabled || false;
    this.customMinimap = model.customMinimap || false;
    this.menuEnabled = model.menuEnabled || false;
    this.menuOnStart = model.menuOnStart || false;
    this.menuAlwaysOpenMobile = false;
    this.menuAlwaysOpenDesktop = model.menuAlwaysOpenDesktop || false;
    this.music = model.music || false;
    this.autoplayMusic = model.autoplayMusic;
    this.audioVolume = model.audioVolume;
    this.screenshotEnabled = model.screenshotEnabled || false;
    this.status = model.status || TourStatus.Idle;
    this.matterId = model.matterId || null;
    this.images = model.images || [];
    this.showTitle = model.showTitle || false;
    this.floorPlans = model.floorPlans || [];
    this.tags = model.tags || [];
    this.clientFolderId = model.clientFolderId || null;
    this.updatedAt = model.updatedAt ? moment(model.updatedAt) : moment();
    this.client = model.client ? new Client(model.client) : null;
    this.tokenDuration = model.tokenDuration || -1;
    this.description = model.description || null;
    this.assetDescription = model.assetDescription || null;
    this.price = model.price || null;
    this.appointmentTime = model.appointmentTime || 30;
    this.fee = model.fee || 0;
    this.unitSystem = model.unitSystem || UnitSystem.Metric;
    this.appointmentsOn = model.appointmentsOn || false;
    this.agentSelecting = model.agentSelecting || false;
    this.appointmentTooltipOn = isNil(model.appointmentTooltipOn) || model.appointmentTooltipOn;
    this.enableAvatar = isNil(model.enableAvatar) || model.enableAvatar;
    this.enableIot = isNil(model.enableIot) || model.enableIot;
    this.iot2FAEnabled = isNil(model.iot2FAEnabled) || model.iot2FAEnabled;
    this.imageInsteadOfAvatar = isNil(model.imageInsteadOfAvatar) || model.imageInsteadOfAvatar;
    this.getInTouchTooltipOn = isNil(model.getInTouchTooltipOn) || model.getInTouchTooltipOn;
    this.menuTooltipOn = isNil(model.menuTooltipOn) || model.menuTooltipOn;
    this.timezone = model.timezone || 0;
    this.sweepGroups = model.sweepGroups || [];
    this.unbranded = model.unbranded || false;
    this.translation = model.translation || null;
    this.messengerLink = model.messengerLink || null;
    this.messengerGreeting = model.messengerGreeting || null;
    this.assetPageType = model.assetPageType || AssetPageType.Classic;
    this.reel = model.reel || false;
    this.reels = model.reels || [];
    this.reelCategories = model.reelCategories || [];
    this.brightness = model.brightness || 1;
    this.saturation = model.saturation || 1;
    this.contrast = model.contrast || 1;
    this.contactForm = model.contactForm || false;
    this.panoramaStart = model.panoramaStart || false;
    this.panoramaCompass = model.panoramaCompass ?? false;
    this.panoramaHd = model.panoramaHd || false;
    this.hideMinimapHotspots = model.hideMinimapHotspots || false;
    this.showIotOnMinimap = model.showIotOnMinimap || false;
    this.enableVS = model.enableVS || false;
    this.allowGuestBeforeHost = model.allowGuestBeforeHost || false;
    this.collectLeads = model.collectLeads || false;
    this.leadsEmail = model.leadsEmail || false;
    this.leadsPhone = model.leadsPhone || false;
    this.leadsTimedPhone = model.leadsTimedPhone || false;
    this.leadsTimedName = model.leadsTimedName || false;
    this.leadsTimedEmail = model.leadsTimedEmail || false;
    this.leadsComment = model.leadsComment || null;
    this.legalNote = model.legalNote || null;
    this.legalBookingBox = model.legalBookingBox || null;
    this.legalBookingBox2 = model.legalBookingBox2 || null;
    this.termsUrl = model.termsUrl || null;
    this.enableBlackColorMenu = model.enableBlackColorMenu || false;
    this.vsRenderRange = model.vsRenderRange || 25;
    this.vsAnimationDistance =
      model.vsAnimationDistance && model.vsAnimationDistance > 0 ? model.vsAnimationDistance : 5;
    this.mpReel = model.mpReel || false;
    this.mpPlay = model.mpPlay || false;
    this.hidePucks = model.hidePucks;
    this.menuSearch = model.menuSearch || false;
    this.menuCategoryExpand = model.menuCategoryExpand || false;
    this.hideCookie = model.hideCookie || false;
    this.registrationBackground = model.registrationBackground || null;
    this.oauthAccess = model.oauthAccess;
    this.tourEmail = model.tourEmail || {
      contactName: null,
      contactPhone: null,
      leadSweeps: null,
      leadForms: null,
      videoAppointment: null,
      assertContactIcon: null,
      assertGetInTouch: null,
      menuGetInTouch: null,
    };
    this.noAudioMode = model.noAudioMode || false;
    this.mode = model.mode;
    this.gameId = model.gameId || null;
    this.hideClientContact = model.hideClientContact || false;
    this.musics = model.tourMusics || [];
    this.agents =
      model.agentTours && model.agentTours.map((agentTour: any) => new Agent(agentTour.agent));
    this.htmlActive = model.htmlActive || false;
    this.htmlCode = model.htmlCode || '';
    // URL Addons
    Object.keys(TourAddons).forEach((addon: string) => {
      this[`addon_${addon}`] = model[`addon_${addon}`] || 0;
    });
    this.amenities = model.amenities || null;
    this.publicId = model.matterId ? encodeURIComponent(btoa(model.matterId)) : null;
    this.scannedAt = model.scannedAt
      ? moment(model.scannedAt).format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');

    this.showNavTools = model.showNavTools || false;
    this.stopAfterSweep = model.stopAfterSweep || 0;
    this.rotationAngle = model.rotationAngle || 0;
    this.rotationSpeed = model.rotationSpeed || 0;
    this.transitionSpeed = model.transitionSpeed || 0;
    this.showNavPath = model.showNavPath || false;
    this.walkNav = model.walkNav || false;
    this.teleportNav = model.teleportNav || false;
    this.autoNav = model.autoNav || false;
    this.customButton = model.customButton || false;
    this.customButtonIcon = model.customButtonIcon || null;
    this.customButtonUrl = model.customButtonUrl || null;
    this.customButtonOpenAs = model.customButtonOpenAs || CustomButtonTypeOpenAsType.Tab;
    this.ecommerceSubscriptionId = model.ecommerceSubscriptionId || null;
    this.mpPasswordActive = model.mpPasswordActive || false;
    this.musicControl = model.musicControl ?? true;
    this.languageId = model.languageId ?? null;
    this.initialDuplicates = model.initialDuplicates ?? [];
    this.isSample = model.isSample || false;
    this.storeEnabled = model.storeEnabled ?? true;
    this.callIconEnabled = model.callIconEnabled ?? false;
    this.addressIconEnabled = model.addressIconEnabled ?? false;
    this.hideSidebarConfigs = model.hideSidebarConfigs ?? false;
    this.hideSoundControls = model.hideSoundControls ?? false;
    this.hideLanguageSelect = model.hideLanguageSelect ?? false;
    this.hideSubtitlesSelect = model.hideSubtitlesSelect ?? false;
    this.ss = model.ss || '';
    this.sr = model.sr || '';
    this.hideMPTagSwitcher = model.hideMPTagSwitcher || false;
    this.hideMPTagDock = model.hideMPTagDock || false;
    this.background = model.background || null;
    this.backgroundImage = model.backgroundImage || null;
    this.cookieIsMandatory = model.cookieIsMandatory;
    this.loadTourAfterCookie = model.loadTourAfterCookie;
    this.cookieBackgroundImage = model.cookieBackgroundImage ?? '';
    this.cookieBackgroundVideo = model.cookieBackgroundVideo ?? '';
    this.cookieBackgroundVideoUrl = model.cookieBackgroundVideoUrl ?? '';
    this.mpTagDockSide = model.mpTagDockSide || TagDockSideType.Right;
    this.patchIcon = model.patchIcon || '';
    this.patchIconEnabled = model.patchIconEnabled || false;
    this.isThreadsEnabled = model.isThreadsEnabled || false;
    this.isPublic = model.isPublic || false;
    this.tagNotesEnabled = model.tagNotesEnabled || false;
    this.notesTaskManagerModeEnabled = model.notesTaskManagerModeEnabled || false;
    this.textChatEnabled = model.textChatEnabled || false;
    this.navigationWebEnabled = model.navigationWebEnabled || false;
    this.activeNotesIntegration = model.activeNotesIntegration || null;
    this.guestNotesAccess = model.guestNotesAccess || false;
    this.allowedDomains = model.allowedDomains || [];
    this.assetPageSocialSharing = model.assetPageSocialSharing ?? true;
    this.calculateDistanceIn = model.calculateDistanceIn || 'm';
    this.layersEnabled = model.layersEnabled ?? false;
    this.layersStartView = model.layersStartView ?? true;
    this.taiDesign = model.taiDesign ?? false;
    this.layersCloseButton = model.layersCloseButton ?? true;
    this.smartLogoActive = model.smartLogoActive ?? false;
    this.smartLogoAlignment = model.smartLogoAlignment ?? null;
    this.smartLogoUrl = model.smartLogoUrl ?? null;
    this.taiChat = model.taiChat ?? false;
  }

  getAddonsUrl() {
    let string = '&play=1&newtags=1&xruntested=1';
    Object.keys(TourAddons).map((addon: string) => {
      let value = this[`addon_${addon}`] ? '1' : '0';
      if (typeof this[`addon_${addon}`] === 'number' || typeof this[`addon_${addon}`] === 'string')
        value = this[`addon_${addon}`];
      if (addon === 'help' && this[`addon_${addon}`] === -1) value = null;
      if (addon === 'lang' && !this[`addon_${addon}`]) return null;
      if (addon === 'ts') return null; // we do our own ts logic
      string += `&${addon}=${value}`;
      return null;
    });
    return string;
  }
}
